"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _ssrWindow = require("ssr-window");

var _reactTether = _interopRequireDefault(require("react-tether"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _DatePickerCalendar = _interopRequireDefault(require("./DatePickerCalendar"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));

var _Portal = _interopRequireDefault(require("../Portal/Portal"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var DatePicker =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DatePicker, _Component);

  function DatePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DatePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DatePicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onBodyClick", function (evt) {
      if (!_dom.default.parent(evt.target, ".DatePicker-".concat(_this.props.id)) && !_dom.default.parent(evt.target, ".".concat(_this._TETHER_CLASS))) {
        _this.setState({
          showCalendar: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInputFocus", function (evt) {
      _this.setState({
        showCalendar: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInputChange", function (selectedDate) {
      _this.setState({
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onDateChange", function (selectedDate) {
      _this.setState({
        showCalendar: false,
        selectedDate: selectedDate,
        tetherKey: (0, _v.default)()
      });
    });
    var id = props.id,
        _selectedDate = props.selectedDate;

    if (!id) {
      throw new Error("The prop 'id' is required to make DatePicker accessible for users using assistive technologies such as screen readers. Check the render method of DatePicker.");
    }

    _this._TETHER_CLASS = "DatePicker-tether-".concat(id);
    _this.state = {
      showCalendar: false,
      selectedDate: _selectedDate,
      tetherKey: (0, _v.default)()
    };
    return _this;
  }

  (0, _createClass2.default)(DatePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          useTetherShim = _this$props.useTetherShim,
          onChange = _this$props.onChange;
      var _this$state = this.state,
          showCalendar = _this$state.showCalendar,
          selectedDate = _this$state.selectedDate;
      var prevShowCalendar = prevState.showCalendar,
          prevSelectedDate = prevState.selectedDate;

      if (showCalendar && showCalendar !== prevShowCalendar) {
        _ssrWindow.document.body.addEventListener('click', this._onBodyClick);

        if (useTetherShim) {
          _dom.default.addClass('html', 'DatePicker-tether-shim-open');
        }
      } else {
        this._removeBodyClickListener();
      }

      if (selectedDate !== prevSelectedDate && onChange) {
        onChange(selectedDate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._removeBodyClickListener();
    }
  }, {
    key: "_removeBodyClickListener",
    value: function _removeBodyClickListener() {
      _ssrWindow.document.body.removeEventListener('click', this._onBodyClick);

      if (this.props.useTetherShim) {
        _dom.default.removeClass('html', 'DatePicker-tether-shim-open');
      }
    }
    /**
     * Getter for the input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id,
          calendarClassName = _this$props2.calendarClassName,
          disabled = _this$props2.disabled,
          disablePast = _this$props2.disablePast,
          disableBefore = _this$props2.disableBefore,
          disableAfter = _this$props2.disableAfter,
          label = _this$props2.label,
          name = _this$props2.name,
          useIcon = _this$props2.useIcon,
          placeholder = _this$props2.placeholder,
          useTetherShim = _this$props2.useTetherShim,
          autoFocus = _this$props2.autoFocus,
          focus = _this$props2.focus,
          overrideInitialMonthWithSelected = _this$props2.overrideInitialMonthWithSelected;
      var _this$state2 = this.state,
          showCalendar = _this$state2.showCalendar,
          tetherKey = _this$state2.tetherKey,
          selectedDate = _this$state2.selectedDate;
      var classes = (0, _classnames.default)('DatePicker', "DatePicker-".concat(id), {
        'DatePicker-disabled': disabled
      }, className);
      var containerClasses = (0, _classnames.default)('DatePicker-input-container', {
        'DatePicker-input-container-with-icon': useIcon
      });
      var tetherClasses = (0, _classnames.default)('DatePicker-tether', {
        'DatePicker-tether-centered-with-shim': useTetherShim
      }, this._TETHER_CLASS);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement("div", {
        className: containerClasses
      }, label, _react.default.createElement(_reactTether.default, {
        key: tetherKey,
        className: tetherClasses,
        attachment: "top left",
        targetAttachment: "bottom left",
        constraints: [{
          to: 'window',
          pin: true
        }]
      }, _react.default.createElement(_TextInput.default, {
        ref: function ref(node) {
          _this2._textInput = node;
        },
        name: name,
        disabled: disabled,
        defaultValue: selectedDate,
        onFocus: this._onInputFocus,
        icon: useIcon ? _react.default.createElement(_Icon.default, {
          name: "calendar"
        }) : null,
        iconPosition: "right",
        autoFocus: autoFocus,
        focus: focus,
        placeholder: placeholder,
        readOnly: true
      }), showCalendar && _react.default.createElement(_DatePickerCalendar.default, {
        className: calendarClassName,
        onChange: this._onDateChange,
        selectedDate: this.state.selectedDate,
        disablePast: disablePast,
        disableBefore: disableBefore,
        disableAfter: disableAfter,
        overrideInitialMonthWithSelected: overrideInitialMonthWithSelected
      })), useTetherShim && showCalendar && _react.default.createElement(_Portal.default, null, _react.default.createElement("div", {
        className: "DatePicker-calendar-shim"
      }))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "node",
    get: function get() {
      return this._textInput.node;
    }
  }]);
  return DatePicker;
}(_react.Component);

exports.default = DatePicker;
(0, _defineProperty2.default)(DatePicker, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique ID which is used to identify this element for accessibility purposes on the client as well as the server. */
  id: _propTypes.default.string.isRequired,

  /** Additional class(es) to add to the the underlying calendar component. */
  calendarClassName: _propTypes.default.string,

  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for serialization and is required. */
  name: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the date which should be selected. */
  selectedDate: _propTypes.default.string,

  /** Whether to show the calendar icon in the input field. */
  useIcon: _propTypes.default.bool,

  /** Whether the DatePicker is disabled or not. */
  disabled: _propTypes.default.bool,

  /** A custom label (typically a Label component) to display above the input. */
  label: _propTypes.default.element,

  /** The placeholder text to show in the input before a selection is made. */
  placeholder: _propTypes.default.string,

  /** Whether the field should be auto focused when mounted. */
  autoFocus: _propTypes.default.bool,

  /** Whether the field should be focused when the component receives new prop of focus={true}. */
  focus: _propTypes.default.bool,

  /** Whether to disable days before today. */
  disablePast: _propTypes.default.bool,

  /** A string in the format 'MM/DD/YYYY' representing the date where days before it should be disabled in the calendar. */
  disableBefore: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the date where days after it should be disabled in the calendar. */
  disableAfter: _propTypes.default.string,

  /** Puts the calendar in the center of the page with a shim behind it. */
  useTetherShim: _propTypes.default.bool,

  /** Whether to set the initial month to show in the calendar to the same month as the selected day falls within when a day is selected. */
  overrideInitialMonthWithSelected: _propTypes.default.bool,

  /**
   * Function to execute when the selected date changes.
   *
   * @param {String} selectedDate - The selected date in the format 'MM/DD/YYYY'.
   */
  onChange: _propTypes.default.func
});
(0, _defineProperty2.default)(DatePicker, "defaultProps", {
  disablePast: true,
  useIcon: true,
  overrideInitialMonthWithSelected: true
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DatePicker, "DatePicker", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/DatePicker.jsx");
  leaveModule(module);
})();

;